import React, { useCallback, useEffect, useState } from "react";

import { FiEye, FiEyeOff } from "react-icons/fi";

import {
  Container,
  ContainerIcon,
  ContainerInput,
  InputText,
  Label,
} from "./styles";
import { CircleBadge } from "../Badges/Circle";

type IInput = {
  id?: string;
  width?: number;
  height?: number;
  marginLeft?: number;
  label: string;
  value?: string | number;
  icon?: boolean;
  maxLength?: number;
  mt?: string;
  type?: "text" | "number" | "password";
  error?: boolean;
  setType?: (e: any) => unknown;
  onChange: (e: string) => unknown;
  disabled?: boolean;
  required?: boolean;
  nativeRequired?: boolean;
  placeholder?: string;
  onClick?: any;
  startFocus?: boolean;
  ref?: any; //HTMLInputElement
  inputRef?: React.Ref<HTMLInputElement>;
  pattern?: any;
  onKeyPress?: (e: any) => unknown;
  marginBottomContainer?: string;
  helperText?: string | React.ReactNode;
};

export const InputGeneral: React.FC<IInput> = ({
  id,
  label,
  maxLength,
  onChange,
  value,
  disabled = false,
  error = false,
  type = "text",
  setType,
  icon = false,
  width,
  mt,
  height,
  required,
  nativeRequired,
  marginLeft,
  marginBottomContainer,
  placeholder,
  onClick,
  pattern,
  startFocus = true,
  onKeyPress,
  helperText,
  inputRef,
}) => {
  const [focus, setFocus] = useState<boolean>(false);
  const [, setFocusInputError] = useState<boolean>(false);

  const activeFocus = () => {
    setFocus(true);
    setFocusInputError(true);
  };

  const inactiveFocus = () => {
    setFocus(false);
    setFocusInputError(false);
  };

  const internalInputRef = React.useRef<HTMLInputElement | null>(null);

  const setInputRefs = useCallback(
    (node: HTMLInputElement | null) => {
      internalInputRef.current = node;
      if (!inputRef) {
        return;
      }
      if (typeof inputRef === "function") {
        inputRef(node);
        return;
      }
      (inputRef as React.MutableRefObject<HTMLInputElement | null>).current =
        node;
    },
    [inputRef],
  );

  useEffect(() => {
    if (startFocus) {
      focusInput();
    } else {
      blurInput();
    }
  }, []);

  function focusInput() {
    if (internalInputRef.current) {
      internalInputRef.current.focus();
    }
  }

  function blurInput() {
    if (internalInputRef.current) {
      internalInputRef.current.blur();
    }
  }

  // function verifyLastCharacterEmpty(target: string) {
  //   if (target) {
  //     if (typeof target === "string") {
  //       let res = target.charAt(target.length - 1);
  //       if (stringFormat.isEmptyOrSpaces(res)) {
  //         return true;
  //       }
  //       return false;
  //     }
  //   }
  // }

  return (
    <>
      <Container
        marginTop={mt}
        style={{
          marginLeft: marginLeft,
          width: width,
          marginBottom: marginBottomContainer,
        }}
      >
        <Label>{label}</Label>
        {required && !disabled && (
          <CircleBadge radius="50px" widthHeigt="8px" />
        )}
        <ContainerInput
          width={width}
          height={height}
          notError={false}
          error={error}
          focus={focus}
        >
          <InputText
            id={id}
            data-cy={id}
            onSubmit={(e) => e.preventDefault()}
            maxLength={maxLength}
            onFocus={activeFocus}
            onBlur={inactiveFocus}
            autoComplete="on"
            autoCapitalize="off"
            disabled={disabled}
            placeholder={placeholder}
            type={type}
            value={value}
            onClick={onClick}
            required={nativeRequired ?? required}
            ref={setInputRefs}
            pattern={pattern}
            onChange={(e) => onChange(e.target.value)}
            onKeyPress={onKeyPress}
          />
          {icon && setType && (
            <ContainerIcon
              onClick={() => setType(type === "text" ? "password" : "text")}
              type="button"
            >
              {type === "text" ? (
                <FiEyeOff color="#7887A9" size={20} />
              ) : (
                <FiEye color="#7887A9" size={20} />
              )}
            </ContainerIcon>
          )}
        </ContainerInput>
        {error && helperText && (
          <div
            style={{
              marginTop: "4px",
              color: error ? "#FF4D4F" : "#595959",
              fontSize: "12px",
            }}
          >
            {helperText}
          </div>
        )}
      </Container>
    </>
  );
};
